import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Overdue.module.css";

type OverdueProps = {
  text: string;
};

function Overdue({ text }: OverdueProps) {
  return (
    <FixaText data-testid="overdue" className={styles["root"]}>
      {text}
    </FixaText>
  );
}

export default Overdue;
